<template>
  <div class="systemSetup">
    <el-button type="primary" class="userButton" @click="exportAll">导出全部测试记录</el-button>
    <el-table :data="userList" style="width:99%;border:1px solid #eee;margin:auto;margin-bottom:1%;" :header-cell-style="getRowClass"
      @selection-change="handleSelectionChange" v-loading="loading">
      <el-table-column type="index" align="center" label="序号" width="80"></el-table-column>
      <el-table-column v-if="false" prop="record_id" header-align="center" align="center">
      </el-table-column>
      <el-table-column prop="project_name" align="center" class-name="userName" label="被测设备"></el-table-column>
      <el-table-column prop="data_num" align="center" label="有效数据（条）"></el-table-column>
      <el-table-column align="center" label="平均时延">
        <template slot-scope="scope">
          <span>{{scope.row.cscfavg}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cscfMax" align="center" label="最大时延"></el-table-column>
      <el-table-column prop="cscfMin" align="center" label="最小时延"></el-table-column>
      <el-table-column prop="save_time" align="center" label="时间"></el-table-column>
      <el-table-column align="center" label="操作" width="240px">
        <template slot-scope="scope">
          <el-button type="primary" plain class="centerBtn" size="small" @click="resetPassword(scope.row)">详情查看</el-button>
          <el-button type="primary" plain class="centerBtn" size="small" @click="theExport(scope.row)">导出测试记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align:center">
      <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="prev, pager, next" :total="totalProject"
        @current-change="thPageChange" v-if="totalProject>pageSize">
      </el-pagination>
    </div>
    <!-- 详情查看 -->
    <el-dialog title="详情查看" :visible.sync="details" width="750px">
      <el-row>
        <el-col :span="12">
          <div class="news">
            <span class="theTap">时延测试结果</span>
            <ul>
              <li><span>有效数据：</span>&nbsp;{{effective}}&nbsp;(条)</li>
              <li><span>最大时延：</span>&nbsp;{{maxresult}}&nbsp;(μs)</li>
            </ul>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="news">
            <span class="theTap"></span>
            <ul>
              <li><span>平均时延：</span>&nbsp;{{cscfAvg}}&nbsp;(μs)</li>
              <li><span>最小时延：</span>&nbsp;{{minresult}}&nbsp;(μs)</li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <div class="news">
            <span class="theTap">最大时延详情</span>
            <ul>
              <li><span>UE_id：</span>&nbsp;{{cscfMax.tel}}&nbsp;</li>
              <li><span>基准时间：</span>&nbsp;{{cscfMax.sipm | makeData}}&nbsp;(s)</li>
              <li><span>时延时间：</span>&nbsp;{{cscfMax.cscfm | makeData}}&nbsp;(s)</li>
            </ul>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="news">
            <span class="theTap"></span>
            <ul>
              <li></li>
              <li><span></span>&nbsp;{{cscfMax.sipms | makeData}}&nbsp;(μs)</li>
              <li><span></span>&nbsp;{{cscfMax.cscfms | makeData}}&nbsp;(μs)</li>
            </ul>
          </div>
        </el-col>
      </el-row>
      <br>
      <el-row>
        <el-col :span="12">
          <div class="news">
            <span class="theTap">最小时延详情</span>
            <ul>
              <li><span>UE_id：</span>&nbsp;{{cscfMin.tel}}&nbsp;</li>
              <li><span>基准时间：</span>&nbsp;{{cscfMin.sipm | makeData}}&nbsp;(s)</li>
              <li><span>时延时间：</span>&nbsp;{{cscfMin.cscfm | makeData}}&nbsp;(s)</li>
            </ul>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="news">
            <span class="theTap"></span>
            <ul>
              <li></li>
              <li><span></span>&nbsp;{{cscfMin.sipms | makeData}}&nbsp;(μs)</li>
              <li><span></span>&nbsp;{{cscfMin.cscfms | makeData}}&nbsp;(μs)</li>
            </ul>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
  import api from '@/api/home';
  import {
    downloadUrl
  } from '@/common/common';
  export default {
    name: 'systemSetup',
    data() {
      return {
        manageUser: false,
        sadf: "123",
        userList: [],
        userTable: {},
        loading: false,
        totalProject: 0, //表格总条数
        pageSize: 8, //表格每页条数
        currentPage: 1, //表格当前页数
        details: '',
        details: false,
        cscfMax: {},
        cscfMin: {},
        theName: '',
        effective: '', //4个值
        cscfAvg: '',
        maxresult: '',
        minresult: '',
      }
    },
    filters: {
      makeData: str => {
        if (str) {
          str = Number(str).toFixed(0).toString().split('').reverse().join('').replace(/(\d{3})/g,
            '$1,').split('').reverse().join(
            '')
          if (str.substring(0, 1) == '-' && str.substring(1, 2) == ',') {
            return str = str.slice(0, 1) + str.slice(2, str.length)
          } else {
            if (str.substring(0, 1) == ',') {
              return str.slice(1, str.length)
            } else {
              return str
            }
          }
        } else {
          if (str == 0) {
            return str
          } else {
            return ''
          }
        }
      }
    },
    created() {
      this.getRecordList()
    },
    methods: {
      makeData(str) {
        if (str) {
          str = Number(str).toFixed(0).toString().split('').reverse().join('').replace(/(\d{3})/g,
            '$1,').split('').reverse().join(
            '')
          if (str.substring(0, 1) == '-' && str.substring(1, 2) == ',') {
            return str = str.slice(0, 1) + str.slice(2, str.length)
          } else {
            if (str.substring(0, 1) == ',') {
              return str.slice(1, str.length)
            } else {
              return str
            }
          }
        } else {
          if (str == 0) {
            return str
          } else {
            return ''
          }
        }
      },
      // 列表详情查看
      resetPassword(s) {
        this.effective = s.data_num;
        this.cscfAvg = s.cscfavg;
        this.maxresult = s.cscfMax;
        this.minresult = s.cscfMin;
        this.details = true;
        this.theName = "被测设备：" + s.project_name;
        api.SelectDetails({
          recordId: s.record_id
        }).then(res => {
          if (res.data.status == 200) {
            this.cscfMax = res.data.cscfMax;
            this.cscfMin = res.data.cscfMin;
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      //记录列表全查
      getRecordList() {
        this.loading = true;
        api.SelectRecord({
          page: this.currentPage,
          pageSize: this.pageSize
        }).then(res => {
          if (res.data.status == 200) {
            this.userList = res.data.list;
            this.totalProject = res.data.count;
            this.loading = false;
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      // 改变当前页
      thPageChange(val) {
        this.currentPage = val;
        this.getRecordList()
      },
      //表头样式
      getRowClass({
        row,
        column,
        rowIndex,
        columnIndex
      }) {
        if (rowIndex === 0) {
          return "background:#f9f9f9"
        } else {
          return ''
        }
      },
      handleSelectionChange(val) {
        this.selectVal = val;
      },
      // 导出全部记录
      exportAll() {
        window.location.href = downloadUrl + 'nausf-auth/getSalesdownloadSalesFile'
        // window.location.href = 'http://192.168.3.139:8080/nausf-auth/getSalesdownloadSalesFile'
        // window.location.href = 'http://192.168.3.105:8080/nausf-auth/getSalesdownloadSalesFile'
        // window.location.href = 'http://192.168.3.73:8080/nausf-auth/getSalesdownloadSalesFile'
        // window.location.href = 'http://10.163.135.219:8080/nausf-auth/getSalesdownloadSalesFile'
        // window.location.href = 'http://choidata.choicete.com:8080/nausf-auth/getSalesdownloadSalesFile'
      },
      //下载本条记录
      theExport(s) {
        window.location.href = downloadUrl + 'nausf-auth/downloadone?recordId=' + s.record_id
        // window.location.href = 'http://192.168.3.139:8080/nausf-auth/downloadone?recordId=' + s.record_id
        // window.location.href = 'http://192.168.3.105:8080/nausf-auth/downloadone?recordId=' + s.record_id
        // window.location.href = 'http://192.168.3.73:8080/nausf-auth/downloadone?recordId=' + s.record_id
        // window.location.href = 'http://10.163.135.219:8080/nausf-auth/downloadone?recordId=' + s.record_id
        // window.location.href = 'http://choidata.choicete.com:8080/nausf-auth/downloadone?recordId=' + s.record_id
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .systemSetup {
    margin: 10px;

    .inputSize {
      width: 86%;
    }

    .inputSizes {
      width: 39%;
    }

    .theDataInput {
      width: 220px;
    }

    .formSet {
      width: 100%;

      .el-form-item {
        float: left;
        width: 50%;
      }

      .el-input__inner {
        width: 150px;
      }
    }

    .news {
      width: 100%;

      .theTap {
        display: inline-block;
        width: 100%;
        height: 25px;
        line-height: 30px;
        text-align: left;
        margin-left: 20px;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 2px;
      }

      ul {
        width: 100%;

        li {
          list-style: none;
          height: 28px;
          line-height: 20px;
          text-align: left;
          margin-left: 30px;
          margin-top: 20px;
          font-size: 16px;
        }
      }
    }

    .userButton {
      float: left;
      margin-left: 10px;
      margin-bottom: 8px;
    }

    .userInput {
      width: 98%;
    }
  }

</style>
<style lang="scss">
  .systemSetup .el-table__header thead>tr:nth-of-type(1)>.el-table-column--selection>.cell {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/systemSetup.vue